import { SensorsPlacements, SensorPlacement } from '../../../../../backbone-unorganized/shared/sensors/models';

export const PlacementOptionsView = Backbone.Marionette.ItemView.extend({
    template: '#tpl_placement_options',
    placements: new SensorsPlacements(), // SensorsPlacements
    model: null, // Sensor
    onSelect: function () {},

    templateHelpers: function () {
        return {
            placements: this.placements,
            selected_id: this.model?.get('id')
        };
    },

    events: {
        'change input[type=radio]': 'handleOnSelect'
    },

    initialize: function (options) {
        options = options || {};
        $.extend(this, options);
        this.loadInitialData();
    },

    loadInitialData: async function () {
        await this.fetchPlacements();
        this.render();
    },

    fetchPlacements: function () {
        this.placements = new SensorsPlacements();

        return new Promise((resolve, reject) => {
            this.placements.fetch({
                success: resolve,
                error: reject
            });
        });
    },

    handleOnSelect: function (event) {
        const target = $(event.target);
        if (!this.model) this.model = new SensorPlacement();

        this.model.set({ id: parseInt(target.attr('id')), name: target.attr('value') });
        this.onSelect(this.model);
    }
});
